import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { categoryUpdate } from '../actions/index';

class MenuCategories extends Component {

  // Update the category
  handleCategoryUpdate(categoryID) {
    this.props.categoryUpdate(categoryID);
  }

  renderCatList(items) {
    var categories = Object.values(this.props.restaurant.menuItems);

    return categories.map( (item, index) => {
      var cls = (item.id === this.props.restaurant.activeCategory.id) ? 'nav-item active' : 'nav-item';
      return(
        <li key={item.id} className={cls}>
          <a
            onClick={event => this.handleCategoryUpdate(item.id)}
            className="nav-link"
            href={"#" + item.id}>
              {item.name.toUpperCase()}
          </a>
        </li>
      );
    });
  }

  render() {
    return(
      <ul className="nav navbar-nav">
        {this.renderCatList()}
      </ul>
    );
  }
}

function mapStateToProps({ restaurant }) {
  return { restaurant };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators( { categoryUpdate }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuCategories);



// WEBPACK FOOTER //
// ./src/components/menu_categories.js